module.exports = __webpack_public_path__ + "img/NoAssignedNurse.6e7b0d60.svg";